export default __webpack_public_path__ + "static/media/el5.01b91b97.jpeg";